'use client';

import { FC, PropsWithChildren } from 'react';
import { Portal, Drawer } from 'components/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';
import { useDealerLocatorDrawer } from '../dealer-locator-drawer-context';
import { useDealerLocatorLoader } from '../dealer-locator-loader-context';
import styles from '../dealer-locator-content/dealer-locator-content.module.scss';

export const DealerLocatorDrawerWrapper: FC<PropsWithChildren> = ({
  children
}) => {
  const dealerLocatorDrawer = useDealerLocatorDrawer();
  const dealerLocatorLoader = useDealerLocatorLoader();

  return (
    <Portal id={ROOT_PORTALS}>
      <Drawer
        {...dealerLocatorDrawer?.drawerProps}
        disableBackdropClick={
          dealerLocatorLoader?.isDealerLocatorLoading ||
          dealerLocatorDrawer?.drawerProps?.disableBackdropClick
        }
        hideCloseButton={
          dealerLocatorLoader?.isDealerLocatorLoading ||
          dealerLocatorDrawer?.drawerProps?.hideCloseButton
        }
        hasBackdrop={
          !dealerLocatorLoader?.isDealerLocatorLoading &&
          dealerLocatorDrawer?.drawerProps?.hasBackdrop
        }
        className={styles['dealer-locator-drawer']}
      >
        {children}
      </Drawer>
    </Portal>
  );
};
